/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/moon'
export default icon
